const firebaseConfig = {
    apiKey: "AIzaSyAghpXLPZZPBGONL-myOMT5NMD0JAMt0gs",
    authDomain: "mygithubapp-f9f6d.firebaseapp.com",
    projectId: "mygithubapp-f9f6d",
    storageBucket: "mygithubapp-f9f6d.appspot.com",
    messagingSenderId: "936851334073",
    appId: "1:936851334073:web:beed24ff8014946ad50c68"
  };
export default firebaseConfig;